import { render, staticRenderFns } from "./Lgx02727378374626738439046.vue?vue&type=template&id=2f19aaa2&"
import script from "./Lgx02727378374626738439046.vue?vue&type=script&lang=js&"
export * from "./Lgx02727378374626738439046.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports